import React from "react";
import { useDispatch } from "react-redux";
import { goBack } from "connected-react-router";

import Button from "@material-ui/core/Button";

import useStyles from "./styles";

interface IProps {
  subTitle: string;
  hasUnsavedChanges: boolean;
  onSetShowUnsavedChangesPopup: (value: boolean) => void;
}

const MobileFormHeader = (props: IProps) => {
  const { subTitle, hasUnsavedChanges, onSetShowUnsavedChangesPopup } = props;

  const dispatch = useDispatch();
  const classes = useStyles();

  const handleCancelClick = () => {
    if (hasUnsavedChanges) {
      onSetShowUnsavedChangesPopup(true);
    } else {
      dispatch(goBack());
    }
  };

  return (
    <>
      <Button
        className={classes.pageHeaderButtonCancel}
        onClick={handleCancelClick}
      >
        Cancel
      </Button>
      <span className={classes.pageHeaderTitle}>Intake Form</span>
      <span className={classes.pageHeaderSubTitle}>{subTitle}</span>
    </>
  );
};

export default React.memo(MobileFormHeader);
